import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
 
import zhLocale from "./zh";
import enLocale from "./en";
 
 
const messages = {
  zh: {
    ...zhLocale,
  },
  en: {
    ...enLocale
  }
}
const navLang = navigator.language || navigator.userLanguage
let localLang = navLang || false
let lang = localLang  || 'enUS'
const i18n = new VueI18n({
    locale: lang === "zh-CN" ? 'zh' : 'en',
    messages
})
 
export default i18n;